export var createIsNativeAudioContext = function createIsNativeAudioContext(nativeAudioContextConstructor) {
  return function (anything) {
    return nativeAudioContextConstructor !== null && anything instanceof nativeAudioContextConstructor;
  };
};